import { render } from "./SupportCenter.vue?vue&type=template&id=c701b6b8&scoped=true"
import script from "./SupportCenter.vue?vue&type=script&lang=js"
export * from "./SupportCenter.vue?vue&type=script&lang=js"

import "./SupportCenter.vue?vue&type=style&index=0&id=c701b6b8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c701b6b8"]])

export default __exports__